import React, { useEffect, useState } from 'react';
import './MealViewer.scss';
import axios from 'axios';
import { DateTime } from 'luxon';

const MealViewer = () => {
    const [meals, setMeals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [schoolSelectedValue, setSchoolSelectedValue] = useState('Penn');

    const schoolsEnum = { Penn: 'Penn', NorthCentralJrHigh: 'North Central JR High', LibertyHighSchool: 'North Liberty High School'};

    const handleSchoolDropdownChange = (e) => {
        setSchoolSelectedValue(e.target.value);
    };

    useEffect(() => {
        const fetchMeals = async () => {
            setLoading(true);
            try {
                const addDays = 1;
                const prevDays = 0;
                const startDate = DateTime.now().minus({ days: prevDays }).toFormat("MM-dd-yyyy");
                const endDate = DateTime.now().plus({ days: addDays }).toFormat("MM-dd-yyyy"); console.log(schoolSelectedValue)
                const url = `https://api.mealviewer.com/api/v4/school/${schoolSelectedValue}/${startDate}/${endDate}/0`;
                const { data } = await axios.get(url);
                setMeals(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchMeals();
    }, [schoolSelectedValue]);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    if (loading) return <p>Loading meals...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!meals?.menuSchedules?.length) return <p>No meals available.</p>;

    return (
        <section>
            <div className='d-flex mb-4'>
                <h1 className='flex-fill w-100'>Meals</h1>
                {/* <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onClick={handleSchoolSwitch} />
                    <label class="form-check-label" for="flexSwitchCheckDefault">Default switch checkbox input</label>
                </div> */}
                <select className="form-select align-self-center w-auto" aria-label="School selection for menu" onChange={handleSchoolDropdownChange} value={schoolSelectedValue}>
                    <option value="Penn">Penn Elementary</option>
                    <option value="NorthCentralJrHigh">North Central JR High</option>
                    <option value="LibertyHighSchool">Liberty High School</option>
                </select>
            </div>
            <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    {meals.menuSchedules.map((schedule, index) => (
                        <MealTab key={index} index={index} schedule={schedule} isActive={index === activeTab} onClick={() => handleTabClick(index)} />
                    ))}
                </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
                {meals.menuSchedules.map((schedule, index) => (
                    <MealBlock key={index} schedule={schedule} isActive={index === activeTab} />
                ))}
            </div>
        </section>
    );
};

const MealTab = ({ index, schedule, isActive, onClick }) => {
    const dateFormatted = DateTime.fromISO(schedule.dateInformation.dateFull).toFormat('EEEE, MMM dd');
    const tabId = `nav-${DateTime.fromISO(schedule.dateInformation.dateFull).toFormat('EEEddyy')}`;

    return (
        <button className={`nav-link ${isActive ? 'active' : ''}`} id={`${tabId}-tab`} data-bs-toggle="tab" data-bs-target={`#${tabId}`} type="button" role="tab" aria-controls={tabId} aria-selected={isActive} onClick={onClick}>
            {dateFormatted}
        </button>
    );
};

const MealBlock = ({ schedule, isActive }) => {
    const blockId = `nav-${DateTime.fromISO(schedule.dateInformation.dateFull).toFormat('EEEddyy')}`;

    return (
        <div
            className={`tab-pane fade ${isActive ? 'show active' : ''} p-3`}
            id={blockId}
            role="tabpanel"
            aria-labelledby={`${blockId}-tab`}
        >
            {schedule.menuBlocks?.length ? (
                schedule.menuBlocks.map((line, idx) => (
                    <CafeteriaLine key={idx} line={line} />
                ))
            ) : (
                <p className="alert alert-info p-2">No cafeteria lines available.</p>
            )}
        </div>
    );
};

const CafeteriaLine = ({ line }) => {
    const { blockName, cafeteriaLineList } = line;
    const foodItems = cafeteriaLineList?.data?.[0]?.foodItemList?.data || [];

    return (
        <div>
            <h3>{blockName}</h3>
            {foodItems.length > 0 ? (
                <ul>
                    {foodItems.map((meal, index) => (
                        <li key={index} className="mb-2">
                            {meal.imageFileName ? (
                                <>
                                    <img className="mb-1" src={`${imageURL}${meal.imageFileName}`} width="300" alt={`${meal.item_Name}`} />
                                    <br />
                                </>
                            ) : null}
                            {meal.item_Name}
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No food items available for this block.</p>
            )}
        </div>
    );
};

const imageURL = 'https://custcdn.mealviewer.com/fooditemimages/';

export default MealViewer;
